import { opFor, type LevelId } from '../../data/ids';

export interface GameOverModel {
  levelId: LevelId;
  op: string;
  /** Points and lives as the core restored them (GDD §6.2, rule 6): read, never computed here. */
  score: number;
  lives: number;
}

/** What OPERACIÓN FALLIDA shows (GDD §13.2, issue #61), taken from the run after its game over. */
export function gameOverModel(levelId: LevelId, run: { core: { score: number; lives: number } } | null): GameOverModel {
  return { levelId, op: opFor(levelId), score: run?.core.score ?? 0, lives: run?.core.lives ?? 0 };
}
